<template>
  <div>
    <el-dialog
      title="自定义天数"
      :visible="visible"
      @close="$emit('update:visible', false)"
      @closed="days = 0"
    >
      <div
        slot="title"
        class="Diatitle"
      >
        <span>自定义天数</span>
      </div>
      <el-input-number
        placeholder="自定义天数"
        v-model="days"
        controls-position="right"
        :min="1"
        :max="999999"
        size="small"
        style="width: 40%"
      ></el-input-number>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          @click="$emit('update:visible', false)"
          size="small"
        >取 消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="$emit('autoClick',days)"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      days: 0
    };
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog {
  width: 400px !important;
}
</style>